<template>
    <div>
        <refill-fintech-recommendation
            v-if="recommendation"
            :recommendation="recommendation"
            @dismiss="dismissRecommendation"
        />

        <template v-else>
            <b-alert variant="danger" show v-if="error">
                {{ error }}
            </b-alert>

            <div class="d-flex justify-content-between align-items-center">
                <div>
                    {{ $t("Saved Card") }}
                </div>
                <div>
                    <b-btn
                        @click="createCard"
                        variant="primary"
                        pill
                        class="mt-3"
                        size="sm"
                    >
                        {{ $t("New Card") }}
                    </b-btn>
                </div>
            </div>

            <div>
                <font-awesome-icon
                    icon="fa-duotone fa-credit-card"
                    class="text-primary"
                    size="lg"
                />
                {{ $t("Card ending in ") }}
                {{ onboardingUser.authorizeProfile.lastFour }}
            </div>

            <refill-brand-warning />

            <b-btn
                :disabled="saving"
                @click="chargeCard"
                size="lg"
                variant="primary"
                pill
                block
                class="mt-3"
            >
                {{ $t("Pay") }}
                ${{ price.amount }}
                <div class="small text-opaque">
                    {{ price.localPrice }}
                </div>
            </b-btn>
        </template>
    </div>
</template>

<script>
import { mapState } from "vuex";

import RefillBrandWarning from "@/components/wallet/refill/RefillBrandWarning";
import RefillFintechRecommendation from "@/components/wallet/refill/RefillFintechRecommendation";

export default {
    computed: {
        ...mapState("wallet", ["price"]),
        ...mapState("authorize", ["saving", "error", "recommendation"]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    methods: {
        createCard() {
            this.$store.commit("wallet/setCreateCard", true);
        },
        changePackage() {
            this.$store.commit("wallet/setPrice", null);
        },
        chargeCard() {
            this.$store.dispatch("authorize/chargeDefault", {
                priceId: this.price.id,
            });
        },
        dismissRecommendation() {
            this.$store.commit("authorize/setRecommendation", null);
        },
    },
    components: {
        RefillBrandWarning,
        RefillFintechRecommendation,
    },
};
</script>